import React from 'react';
import { Button, Form, Input, Typography } from 'antd';
import AuthLayout from '../../../Layout/AuthLayout';
import { getRoutes } from '../../../constants/Routes';
import { forgotPassword } from '../../../redux/actions/auth';
import { sendResetPasswordEmail } from '../../../redux/actions/email';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const navigate = useNavigate()
  const handleForgotPassword = async (body) => {
    const res = await forgotPassword(body)
    if (res?.ack) {
      const payload = {
        userEmail: body?.email
      }
      await sendResetPasswordEmail(payload)
      navigate(getRoutes().login.route());
    }
  };

  return (
    <AuthLayout title="Forgot Your Password?" subtitle="Enter your email to reset your password">
      <Form
        name="forgot-password"
        layout="vertical"
        className="ForgotPassword__Form"
        onFinish={handleForgotPassword}
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Please enter your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input size="large" placeholder="Enter your email address" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            block
            className="ForgotPassword__Button"
          >
            Verify Email
          </Button>
        </Form.Item>
      </Form>

      <Typography.Paragraph className="ForgotPassword__BackToLogin">
        Remember your password?{' '}
        <a href={getRoutes().login.route()} className="ForgotPassword__LoginLink">
          Back to Login
        </a>
      </Typography.Paragraph>
    </AuthLayout>
  );
};

export default ForgotPassword;
